type Envelope<T> = { data: T; meta?: unknown };
export class ApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
  ) {
    super(message);
  }
}
export async function api<T>(path: string, options: RequestInit = {}) {
  const response = await fetch(path, {
    credentials: "include",
    ...options,
    headers: {
      ...(options.body instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...options.headers,
    },
  });
  const body = (await response.json().catch(() => null)) as
    Envelope<T> | { error: { code: string; message: string } } | null;
  if (!response.ok) {
    const e =
      body && "error" in body
        ? body.error
        : { code: "REQUEST_FAILED", message: "Request failed." };
    throw new ApiError(e.code, e.message, response.status);
  }
  return (body as Envelope<T>).data;
}
export const post = <T>(path: string, body: unknown) =>
  api<T>(path, { method: "POST", body: JSON.stringify(body) });
export const patch = <T>(path: string, body: unknown) =>
  api<T>(path, { method: "PATCH", body: JSON.stringify(body) });
